import { createSelector } from 'reselect'

import { RootState } from '@/store'

import { UserRoles } from './reducer'

const getContext = (state: RootState) => state.context

export const getOrganization = createSelector(getContext, ({ organization }) => organization)

export const getCurrentOrganizationId = createSelector(getOrganization, organization => organization.id)

export const getCurrentSpaceId = createSelector(getContext, ({ spaceId }) => spaceId)

export const getCurrentUserRoles = createSelector(
  getContext,
  ({ userRoles }) => userRoles || ({ organization: {}, spaces: {} } as UserRoles)
)

export const getSpaceMemberIdToEdit = (state: RootState) => getContext(state).SpaceMemberIdEdit
